export const BUILD_VERSION = '1790001164';
